// Only adopt a newer same-user session already persisted by another browser tab.
// Never sign a logged-out tab back in or switch its account implicitly.
export function newerAuthRotation(current, serialized) {
  try {
    const saved = JSON.parse(serialized)?.state;
    if (!current.token || !current.refreshToken || !current.user?.id || saved?.user?.id !== current.user.id) return null;
    if (!saved.token || !saved.refreshToken || saved.refreshToken === current.refreshToken) return null;
    const savedExpiry = new Date(saved.expiresAt).getTime();
    const currentExpiry = new Date(current.expiresAt).getTime();
    if (!Number.isFinite(savedExpiry) || savedExpiry <= Date.now() || (Number.isFinite(currentExpiry) && savedExpiry <= currentExpiry)) return null;
    return { token: saved.token, refreshToken: saved.refreshToken, expiresAt: saved.expiresAt };
  } catch (_) { return null; }
}
